module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG13f054723e412853ac73aa58a5029d29.13f05472.png";